import { defineComponent as _defineComponent } from 'vue';
import { usePage } from '@inertiajs/inertia-vue3';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';
// import DataTable from 'primevue/datatable';
import DataTable from '@/Components/DataTable.vue';
import Column from 'primevue/column';
import { FilterMatchMode, FilterOperator } from 'primevue/api';
import Sidebar from 'primevue/sidebar';
import Calendar from 'primevue/calendar';
import DeviceEdit from './EditCreate.vue';
import { computed, onMounted, ref } from 'vue';
import { DateTime } from 'luxon';
import { Inertia } from '@inertiajs/inertia';
import { trans } from 'laravel-vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Table',
    setup(__props, { expose }) {
        expose();
        const selectedCity = ref(null);
        const selectedDevices = ref([]);
        const cities = [{ name: 'Elimina Selezionati', code: 'NY' }];
        const filters = ref({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            id: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
            },
            plots: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
            },
            activation_date: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
            },
            warranty_expiration_date: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
            },
        });
        const globalFilterFields = ['code', 'plots', 'serial', 'brand', 'model'];
        const visibleRightDetails = ref(false);
        const visibleRightEdit = ref(false);
        const formatDate = (value) => {
            return DateTime.fromJSDate(value).toLocaleString();
        };
        const page = usePage();
        const devices = computed(() => {
            const data = page.props.value.devices || [];
            data.forEach((d) => {
                if (typeof d.activation_date === 'string') {
                    d.activation_date = DateTime.fromISO(d.activation_date).toJSDate();
                }
                if (typeof d.warranty_expiration_date === 'string') {
                    d.warranty_expiration_date = DateTime.fromISO(d.warranty_expiration_date).toJSDate();
                }
                if (typeof d.plots !== 'string') {
                    d.plots = d.plots.map((plot) => plot.code).join(', ');
                }
            });
            return data;
        });
        onMounted(() => {
            Inertia.reload({
                only: ['devices'],
            });
        });
        const __returned__ = { selectedCity, selectedDevices, cities, filters, globalFilterFields, visibleRightDetails, visibleRightEdit, formatDate, page, devices, get InputText() { return InputText; }, get Button() { return Button; }, get Dropdown() { return Dropdown; }, DataTable, get Column() { return Column; }, get Sidebar() { return Sidebar; }, get Calendar() { return Calendar; }, DeviceEdit, get trans() { return trans; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
